define('areas/activityfeed/service/activityfeed-service',["require", "exports", "services/httpclient", "areas/activityfeed/models/bindable", "areas/activityfeed/models/dto", "models/account"], function (require, exports, HttpClient, VM, Dto, Account) {
    "use strict";
    var ActivityFeedService = (function () {
        function ActivityFeedService() {
        }
        ActivityFeedService.prototype.getActivityFeedItems = function () {
            var _this = this;
            var service = new HttpClient.Channel();
            var requestUrl = "/api/activityfeed/" + Account.Principal.current.organizationId + "/" + Account.Principal.current.identityId;
            return service.getDataAsync(requestUrl, HttpClient.ServiceTarget.portalApi)
                .then(function (response) {
                var activityfeeditems = new Dto.ActivityFeedServiceModel();
                activityfeeditems.activityVM = new Array();
                if (response.activityFeedList.length != 0) {
                    for (var i = 0; i < response.activityFeedList.length; i++) {
                        var activityfeeditem = new VM.ActivityVM();
                        activityfeeditem.screenName = response.activityFeedList[i].ScreenName;
                        activityfeeditem.text = response.activityFeedList[i].Text.replace(/&amp;/g, "&");
                        activityfeeditem.logoImage = response.activityFeedList[i].ImageUrl;
                        activityfeeditem.type = response.activityFeedList[i].Type;
                        activityfeeditem.urls = [];
                        switch (activityfeeditem.type) {
                            case "cch":
                                activityfeeditem.timelineIcon = "cchdaily";
                                activityfeeditem.url = response.activityFeedList[i].Urls[0];
                                break;
                            case "twitter":
                                activityfeeditem.author = response.activityFeedList[i].Author;
                                activityfeeditem.timelineIcon = "fab fa-twitter iconblue activity-feed-twitter";
                                activityfeeditem.urls = response.activityFeedList[i].Urls;
                                activityfeeditem.url = response.activityFeedList[i].TweetUrl;
                                break;
                            case "portal":
                                activityfeeditem.text = activityfeeditem.text;
                                activityfeeditem.timelineIcon = "central";
                                activityfeeditem.category = response.activityFeedList[i].Content;
                                activityfeeditem.screenName = "Messages & Documents";
                                activityfeeditem.logoImage = response.activityFeedList[i].ImageUrl;
                                break;
                            case "datacollection":
                                activityfeeditem.text = activityfeeditem.text;
                                activityfeeditem.timelineIcon = "datacollection";
                                activityfeeditem.category = response.activityFeedList[i].Content;
                                activityfeeditem.screenName = "Digital Data Request";
                                activityfeeditem.logoImage = response.activityFeedList[i].ImageUrl;
                                break;
                        }
                        activityfeeditem = _this.calculatingTimeDifference(response, activityfeeditem, i);
                        activityfeeditems.activityVM.push(activityfeeditem);
                    }
                }
                activityfeeditems.exceptions = response.exceptions;
                return activityfeeditems;
            })
                .fail(function (error) {
                console.log(error);
                return null;
            });
        };
        // calculating time difference for activities
        ActivityFeedService.prototype.calculatingTimeDifference = function (response, activityfeeditem, position) {
            var date = new Date();
            var localTimeNow = moment(date.toString());
            var activityTime = moment.utc(response.activityFeedList[position].Date.toString()).toDate();
            var activityLocalTime = moment(activityTime).local();
            var minuteDifferenceForActivities = Math.abs(Math.ceil(moment.duration(localTimeNow.diff(activityLocalTime)).asMinutes()));
            if (minuteDifferenceForActivities < 60) {
                activityfeeditem.publishDate = minuteDifferenceForActivities + " min";
            }
            else if (minuteDifferenceForActivities < 2 * 60) {
                activityfeeditem.publishDate = "1 hour";
            }
            else if (minuteDifferenceForActivities < 24 * 60) {
                activityfeeditem.publishDate = Math.floor(minuteDifferenceForActivities / 60) + " hours";
            }
            else {
                activityfeeditem.publishDate = moment(response.activityFeedList[position].Date).format("DD/MM/YY");
            }
            return activityfeeditem;
        };
        return ActivityFeedService;
    }());
    exports.ActivityFeedService = ActivityFeedService;
});

